import React from "react";

// Pre-order banner above the navbar. Dismissible per session.
export default function PreorderBanner() {
  const [hidden, setHidden] = React.useState(false);
  if (hidden) return null;
  return (
    <div data-testid="preorder-banner" className="relative z-[60] bg-adrenaline text-white text-center text-mono text-[11px] sm:text-xs uppercase tracking-[0.25em] py-2 px-4">
      <span className="inline-flex items-center gap-3">
        <span className="hidden sm:inline">★</span>
        Drop 001 Pre-Order Now Open · Ships 3–5 Weeks · Limited Quantities
        <span className="hidden sm:inline">★</span>
      </span>
      <button
        onClick={() => setHidden(true)}
        aria-label="Close banner"
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/80 hover:text-white text-base leading-none"
      >×</button>
    </div>
  );
}
